import { isSameDay, startOfDay } from 'date-fns'
import uniqBy from 'lodash-es/uniqBy'

import { EMPTY_LIST } from '../../../../../constants/common'
import { DATE_WEEKDAY_ABBR_FORMAT } from '../../../../../constants/date'
import { toUkTimezoneDate } from '../../../../../utils/date'
import { formatDate } from '../../../../Table'

export function getViewingFormSlotDays({ items, timezone }) {
  return uniqBy(
    items.map(item => startOfDay(toUkTimezoneDate(item.start, timezone))),
    Number
  )
}

export function getViewingFormSlotSelectedDay({ day, days }) {
  return (
    days.find(availableDay => day && isSameDay(availableDay, day)) ??
    days[0] ??
    null
  )
}

export function getViewingFormSlotDayItems({ items, selectedDay, timezone }) {
  return selectedDay
    ? items.filter(item =>
        isSameDay(toUkTimezoneDate(item.start, timezone), selectedDay)
      )
    : EMPTY_LIST
}

export function getViewingFormSlotDayLabel({ locale, selectedDay, timezone }) {
  return selectedDay
    ? formatDate({
        date: selectedDay,
        dateFormat: DATE_WEEKDAY_ABBR_FORMAT,
        locale,
        timezone,
        useTodayFormat: false,
      })
    : null
}
